import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Pain } from './components/Pain';
import { Stats } from './components/Stats';
import { Revelation } from './components/Revelation';
import { Benefits } from './components/Benefits';
import { Industries } from './components/Industries';
import { About } from './components/About';
import { HowItWorks } from './components/HowItWorks';
import { MainCTA } from './components/MainCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { LanguageProvider } from './i18n/LanguageContext';
import { LanguageModal } from './components/LanguageModal';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-background text-text-primary selection:bg-primary/30 selection:text-white" data-id="element-1">
        <LanguageModal data-id="element-2" />
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <Hero data-id="element-5" />
          <Pain data-id="element-6" />
          <Stats data-id="element-7" />
          <Revelation data-id="element-8" />
          <Benefits data-id="element-9" />
          <Industries data-id="element-10" />
          <About data-id="element-11" />
          <HowItWorks data-id="element-12" />
          <MainCTA data-id="element-13" />
          <FAQ data-id="element-14" />
        </main>
        <Footer data-id="element-15" />
      </div>
    </LanguageProvider>;
}